export const CUSTOMER_SORT_OPTIONS = [
  { value: "newest", label: "Newest",key:'sort_by' },
  { value: "booking", label: "Bookings: Highest to Lowest",key:'sort_by' },
  { value: "revenue", label: "Revenue: Highest to Lowest",key:'sort_by' },
  { value: "balance", label: "Wallet Balance: Highest to Lowest",key:'sort_by' },
  { value: "cancellation", label: "Cancellations: Highest to Lowest",key:'sort_by' },
];

export const BOOKING_SORT_OPTIONS = [
  { value: "newest", label: "Newest",key:'sort_by' },
  { value: "price", label: "Price Highest to Lowest",key:'sort_by' },
  { value: "wallet", label: "Wallet Highest to Lowest",key:'sort_by' },
  { value: "passengers", label: "Passengers Highest to Lowest",key:'sort_by' },
];

export const OPERATOR_SORT_OPTIONS = [
  { value: "newest", label: "Newest Operator",key:'sort_by' },
  { value: "bookings", label: "Bookings Highest to Lowest",key:'sort_by' },
  { value: "fleet_size", label: "Fleet Size Highest to Lowest",key:'sort_by' },
  { value: "revenue", label: "Revenue Highest to Lowest",key:'sort_by' },
];

export const BUS_SORT_OPTIONS = [
  { value: "bookings", label: "Bookings Highest to Lowest",key: "sort_by"  },
  { value: "fleet_size", label: "Fleet Size Highest to Lowest",key: "sort_by"  },
  { value: "revenue", label: "Revenue Highest to Lowest",key: "sort_by"  },
];

export const COUPON_SORT_OPTIONS = [
  { value: "usage", label: "Usage Highest to Lowest", key: "sort_by" },
  { value: "value", label: "Value Highest to Lowest", key: "sort_by" },
];

export const CITY_SORT_OPTIONS = [
  { value: "Newest City", label: "Newest City" },
  { value: "operators", label: "Operators Highest to Lowest" },
  { value: "Buses", label: "Buses Highest to Lowest" },
  { value: "Users", label: "Users Highest to Lowest" },
  { value: "Bookings", label: "Bookings Highest to Lowest" },
  { value: "Revenue", label: "Revenue Highest to Lowest" },
  { value: "Cancellations", label: "Cancellations Highest to Lowest" },
];

export const SETTLEMENT_STATUS_OPTIONS = [
  { value: "asc", label: "Asscending", key: "sort_by" },
  { value: "desc", label: "Descending", key: "sort_by" },
];

export const POS_SORT_OPTIONS = [
  { value: "newest", label: "Newest", key: "sort_by" },
  { value: "oldest", label: "Oldest", key: "sort_by" },
  { value: "revenue_asc", label: "Lowest Revenue", key: "sort_by" },
  { value: "revenue_desc", label: "Highest Revenue", key: "sort_by" },
];

export const POS_BOOKING_SORT_OPTIONS = [
  { value: "newest", label: "Newest", key: "sort_by" },
  { value: "oldest", label: "Oldest", key: "sort_by" },
  { value: "fare_desc", label: "Fare Highest To Lowest", key: "sort_by" },
  { value: "fare_asc", label: "Fare Lowest To Highest", key: "sort_by" },
];

